import ClickAndRevealDisplay from './ClickAndRevealDisplay';

export default ClickAndRevealDisplay;
